// testing without login

// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import WelcomeCard from "./components/WelcomeCard";
// import DisclaimerPage from "./components/DisclaimerPage";
// import UserDetailsForm from "./components/UserDetailsForm";
// import CapturePhoto from "./components/CapturePhoto";
// import ResultPage from "./components/ResultPage";
// import KnowMore from "./components/KnowMore";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Welcome screen is now the root */}
//         <Route path="/" element={<WelcomeCard />} />

//         {/* UserDetails screen*/}
//         <Route path="/user-details" element={<UserDetailsForm />} />

//         {/* Disclaimer Page (New Step) */}
//         <Route path="/disclaimer" element={<DisclaimerPage />} />

//         {/* Capture or upload photo */}
//         <Route path="/capture-photo" element={<CapturePhoto />} />

//         <Route path="/know-more" element={<KnowMore />} />

//         {/* Final result page */}
//         <Route path="/result" element={<ResultPage />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
// import { BackgroundProvider } from "./context/BackgroundContext";
// import { SessionKeyProvider, useSessionKey } from "./context/SessionKeyContext"; // NEW IMPORT

// // Import your components (assuming they are in a 'pages' directory now)
// import WelcomeCard from "./components/WelcomeCard";
// import DisclaimerPage from "./components/DisclaimerPage";
// import UserDetailsForm from "./components/UserDetailsForm";
// import CapturePhoto from "./components/CapturePhoto";
// import ResultPage from "./components/ResultPage";
// import KnowMore from "./components/KnowMore";


// // A component to protect routes based on session key
// const PrivateRoute = () => {
//   const { sessionKey, loadingKey } = useSessionKey();

//   if (loadingKey) {
//     // Optionally render a loading spinner or placeholder while checking key status
//     return <div style={{ color: 'white', fontSize: '24px', textAlign: 'center' }}>Loading...</div>;
//   }

//   // If sessionKey is present, allow access
//   return sessionKey ? <Outlet /> : <Navigate to="/" replace />; // Redirect to welcome if no key
// };

// const App = () => {
//   return (
//     <Router>
//       {/* Ensure SessionKeyProvider wraps BackgroundProvider and Routes */}
//       <SessionKeyProvider>
//         <BackgroundProvider>
//           <Routes>
//             {/* The root route now takes you to WelcomeCard */}
//             <Route path="/" element={<WelcomeCard />} />

//             {/* Disclaimer page - this should be accessible without a key for agreement */}
//             <Route path="/disclaimer" element={<DisclaimerPage />} />

//             {/* Protected Routes - only accessible if a session key is present */}
//             <Route element={<PrivateRoute />}>

//               <Route path="/user-details" element={<UserDetailsForm />} />
//               <Route path="/capture-photo" element={<CapturePhoto />} />
//               <Route path="/result" element={<ResultPage />} />
//               <Route path="/know-more" element={<KnowMore />} />
//               {/* Add more protected routes here */}
//             </Route>

//             {/* Catch-all for undefined routes (optional) */}
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Routes>
//         </BackgroundProvider>
//       </SessionKeyProvider>
//     </Router>
//   );
// };

// export default App;

// for uat
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { BackgroundProvider } from "./context/BackgroundContext";
import { SessionKeyProvider, useSessionKey } from "./context/SessionKeyContext";
import { AuthProvider } from "./context/AuthContext";

// Import your components 
import WelcomeCard from "./components/WelcomeCard";
import AgentPass from "./components/LoginPageAgent";
import LoginPage from "./components/LoginPage";

import UserDetailsForm from "./components/UserDetailsForm";
import CapturePhoto from "./components/CapturePhoto";
import ResultPage from "./components/ResultPage";

const PrivateRoute = () => {
    const { sessionKey, loadingKey } = useSessionKey();

    if (loadingKey) {
        return <div style={{ color: 'white', fontSize: '24px', textAlign: 'center' }}>Loading...</div>;
    }

    // If sessionKey is present, allow access, otherwise redirect to login
    return sessionKey ? <Outlet /> : <Navigate to="/" replace />;
};

const App = () => {
    return (
        <Router>
          <AuthProvider>
            <SessionKeyProvider>
                <BackgroundProvider>
                    <Routes>
                        <Route path="/" element={<WelcomeCard />} />
                        {/* The root route is now the Login Page */}

                        <Route path="/agent-login" element={<AgentPass/>} />
                        <Route path="/login" element={<LoginPage />} />

                        {/* Protected Routes - only accessible if a session key is present */}
                        <Route element={<PrivateRoute />}>
                            <Route path="/user-details" element={<UserDetailsForm />} />
                            <Route path="/capture-photo" element={<CapturePhoto />} />
                            <Route path="/result" element={<ResultPage />} />
                        </Route>

                        {/* Catch-all for undefined routes */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BackgroundProvider>
            </SessionKeyProvider>
          </AuthProvider>
        </Router>
    );
};

export default App;

// for testing locally
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// // import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
// // Import your components 
// import WelcomeCard from "./components/WelcomeCard";
// import AgentPass from "./components/LoginPageAgent";
// import LoginPage from "./components/LoginPage";

// import UserDetailsForm from "./components/UserDetailsForm";
// import CapturePhoto from "./components/CapturePhoto";
// import ResultPage from "./components/ResultPage";

// // Use your new v3 SITE_KEY here
// // const sitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY_LOCAL;

// const App = () => {
//       return (
//         <Router>
//             {/* <GoogleReCaptchaProvider  reCaptchaKey={sitekey}> */}
//             <Routes>
//                 <Route path="/" element={<WelcomeCard/>} />
//                 <Route path="/agent-login" element={<AgentPass/>} />

//                 <Route path="/login" element={<LoginPage />} />
//                 <Route path="/user-details" element={<UserDetailsForm />} />
//                 <Route path="/capture-photo" element={<CapturePhoto />} />
//                 <Route path="/result" element={<ResultPage />} />
//             </Routes>
//             {/* </GoogleReCaptchaProvider> */}
//             </Router>     
//       );
//     }

// export default App;

